module.exports = __webpack_public_path__ + "img/treppenabgang2.bfbb7709.jpg";